import { call, put } from "redux-saga/effects";
import { getToken } from "../authentication";
import axios from 'axios'
import { IgetAllRolesandModules } from "../actions/role-mgmt";
export function* getAllRolesandModules(params: IgetAllRolesandModules) {
    try {
      let { data } = yield call(getAllRolesandModulesApi, params)
      console.log("getALlJobsData",data)
      yield put({
        type: "STORE_ALL_ROLES_AND_MODULES",
        payload: data
      })
    } catch (error) {
      console.error("getALlJobs", error)
    }
  }
  
  export async function getAllRolesandModulesApi(params: IgetAllRolesandModules) {
    const tokenRes = await getToken();
    const response = await axios.get(
      process.env.REACT_APP_WEBAPPAPI + `/getAllModuleAndRole`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: tokenRes.token!,
        },
      }
    )
    return response
  }